/**
 * 2019-04-11
 * handan
 * 调查结果（隐藏信息）
 */

import React, { Component, Fragment } from 'react'
import "./style.scss";

import { connect } from "react-redux";
import { Checkbox, Icon, Modal } from "antd";
import { queryWithPoints, getVipVerifyResultData } from "../../models";

class ResultHide extends Component {
  constructor(props) {
    super(props)
    this.onClickPay = this.onClickPay.bind(this);
    this.onClickVip = this.onClickVip.bind(this);
    this.handleQueryWithPoints = this.handleQueryWithPoints.bind(this);
    this.popDataParamsGood = this.popDataParamsGood.bind(this);
    this.popDataParamsBad = this.popDataParamsBad.bind(this);
  }
  cash() {
    const { data = {} } = this.props;
    return (
      <Fragment>
        {
          data.authStatus == 1 ? (
            <div className="right">
              <Icon className="question" type="question-circle" onClick={this.showIntro} />
              <span className="noAlow">待授权</span>
            </div>
          )  : <div>
            <div className="right cash">
              <p className="nowPrice">¥{data.salePrice}</p>
              {/* <p className="oldPrice">原价¥{data.originalPrice}</p> */}
              <button className="btn2" onClick={this.onClickPay}>支付查看</button>
            </div>
            {/* <div className="discount">{data.discountRate}折</div> */}
          </div>
        }

      </Fragment>
    )
  }
  showIntro = () => {
    Modal.warning({
      icon: <Icon className="question" type="question-circle" />,
      content: '请联系候选人进行授权。系统已发授权短信给候选人，短信以【58同城】开头且带有授权网址。需对方打开网址同意授权后查看背调结果。授权24小时有效，请告知对方及时授',
      okText: '知道了',
      okButtonProps:{
        style:{
          background:' #FF704F',
          border:0,
          borderRadius:0
        }
      }
    })
  }
  point() {
    const { data = {} } = this.props;
    return (
      <Fragment>
        {
          data.authStatus == 1 ? (
            <div className="right">
              <Icon className="question" type="question-circle" onClick={this.showIntro} />
              <span className="noAlow">待授权</span>
            </div>
          ) : <div className="right point">
              <p className="nowPrice"><em>价格：</em>{data.costPoints}背调点数</p>
              <button className="btn2" onClick={this.onClickPay}>支付查看</button>
            </div>
        }
      </Fragment>
    )
  }
  vip() {
    const { vipInfo = 0 } = this.props;
    return (
      <Fragment>
        {
          vipInfo.authStatus == 1 ? (
            <div className="right">
              <Icon className="question" type="question-circle" onClick={this.showIntro} />
              <span className="noAlow">待授权</span>
            </div>
          ) : <div className="right point">
              <p className="nowPrice">招聘{vipInfo.levelDes}权益<em>(剩余{vipInfo.amount}次)</em></p>
              <button className="btn2" onClick={this.onClickVip}>免费查看</button>
            </div>
        }

      </Fragment>
    )
  }
  render() {
    const { pointSum = 0, data = {}, checkedList = [], vipInfo = {} } = this.props;
    let checked = checkedList.indexOf(data.itemId) !== -1;
    let isPoint = pointSum > 0;
    return (
      <div className="resultHide-wrap">
        {
          // data.itemName === "金融违规" &&
          // <div className="zhezhao"><span>金融违规 此项暂停使用</span></div>
        }
        {
          data.authStatus != 1 && <div className="checkbox">
            <Checkbox checked={checked} onChange={(e) => { this.onChecked(e.target.checked, data.itemId) }}></Checkbox>
          </div>
        }

        <div className="content">
          <p>{data.itemName} {data.itemId === 11 && <img className="tag" src='//pic1.58cdn.com.cn/nowater/cxnomark/n_v26a916df50aba4669a2a6f2146db56563.png' />}</p>
          <span>{data.secDesc}</span>
          <div className={"bg " + (data.className ? data.className : "network")}></div>
        </div>
        {data.canUseVip && vipInfo.amount > 0 && this.vip()}
        {!(data.canUseVip && vipInfo.amount > 0) && isPoint && this.point()}
        {!(data.canUseVip && vipInfo.amount > 0) && !isPoint && this.cash()}
      </div>
    )
  }

  onChecked(flag, itemId) {
    const { checkedList = [], setCheckedList } = this.props;
    let newArr = [...checkedList];    // dispatch一个数组的话，这个数组的指针必须改变，就是说需要创建一个全新的数组
    let index = newArr.indexOf(itemId);
    flag ?
      newArr.push(itemId) :
      newArr.splice(index, 1);
    setCheckedList(newArr);
  }
  onClickPay() {
    const { pointSum = 0, data = {}, setPopData, batchId } = this.props;

    let params = {
      batchId,
      clientType: 2,
      costPoint: data.costPoints,
      itemArr: [data.itemId],
      orderMoney: data.salePrice,
      payType: pointSum >= data.costPoints ? 1 : 2,
    }
    if (pointSum >= data.costPoints) {
      // 点够，直接点支付
      this.handleQueryWithPoints(params);
    } else {
      // 点不够或没有点，用钱支付
      setPopData({
        isShowModal: true, // 打开弹框
        isPayModal: true, // 是否使用充值的弹框
        pointSum,
        originalPrice: data.originalPrice,
        params,
      })
    }
  }

  // vip免费支付
  onClickVip() {
    const { pointSum = 0, data = {}, batchId, setLoadingState, getDataCallback } = this.props;
    let params = {
      batchId,
      clientType: 2,
      costPoint: data.costPoints,
      itemArr: [data.itemId],
      orderMoney: data.salePrice,
      payType: pointSum >= data.costPoints ? 1 : 2,
    }
    setLoadingState(true);
    getVipVerifyResultData(params).then(() => {

      setLoadingState(false);
      getDataCallback();
      this.popDataParamsGood("您已成功消耗1次会员权益");

    }).catch(() => {

      setLoadingState(false);
      this.popDataParamsBad();

    })
  }
  // 点支付
  handleQueryWithPoints(params) {
    const { data = {}, setLoadingState, getDataCallback } = this.props;
    setLoadingState(true);
    queryWithPoints(params).then((res) => {

      setLoadingState(false);
      getDataCallback(); // 重新请求数据
      console.log("执行到了getDataCallback方法");
      this.popDataParamsGood(`您已成功支付${data.costPoints}点`);
      // this.props.history.push('/resultHistory')

    }).catch(() => {

      setLoadingState(false);
      this.popDataParamsBad();

    })
  }

  // 支付成功弹框
  popDataParamsGood(text) {
    const { setPopData } = this.props;
    let popData = {
      isShowModal: true,
      isPayModal: false,
      isSuccess: true,
      isOk: true,
      data: {
        title: text,
        text: '系统已发授权短信给候选人，短信以【58同城】开头且带有授权网址。需对方打开网址同意授权后查看背调结果。授权24小时有效，请告知对方及时授权，点击【确定】后进入调查进度',
        buttonText: "确定"
      }
    }
    setPopData(popData);
  }

  // 支付失败弹框
  popDataParamsBad() {
    const { setPopData } = this.props;
    let popData = {
      isShowModal: true,
      isPayModal: false,
      isSuccess: false,
      data: {
        title: "支付失败",
        text: `请检查网络或重新支付`,
        buttonText: "关闭"
      }
    }
    setPopData(popData);
  }
}

const mapState = (store) => {
  return {
    checkedList: store.verifyResult.checkedList,
    pointSum: store.verifyResult.pointSum,
    vipInfo: store.verifyResult.vipInfo,
  }
}
const mapDispatch = (dispatch) => {
  return {
    setCheckedList(data) {
      dispatch({
        type: "setCheckedList",
        data,
      })
    },
    setPopData(data) {
      dispatch({
        type: "setPopData",
        data,
      })
    },
    setLoadingState(data) {
      dispatch({
        type: "setLoadingState",
        data
      })
    },
  }
}
export default connect(mapState, mapDispatch)(ResultHide);
